import {all} from "redux-saga/effects";

import auth from "./auth";
import general from "./general";
import dashboard from "./dashboard";
import elements from "./elements";
import elementClassification from "./element-classification";
import boards from "./boards";
import audit from "./audit";
import tracking from "./tracking";
import media from "./media";
import evaluation from "./evaluation";

export function* sagas() {
  yield all([
    auth,
    general,
    dashboard,
    elements,
    elementClassification,
    boards,
    audit,
    tracking,
    media,
    evaluation
  ])
}
